import { BehaviorSubject } from 'rxjs';
import { CNPrescriptionEntry } from '../models/cnprescriptionentry';
import { SNItem } from '../models/snitem';

export enum SNItemTableControlCapability {
    create,
    sort,
    filter,
    search
}

export enum SNItemTableServiceCapability {
    create,
    sort,
    filter,
    search
}

export interface SNItemTable {
    snOnInit(): void;
}

export interface SNItemTableControl {
    snCapabilities(): SNItemTableControlCapability[];
}

export interface SNItemTableService {
    data: BehaviorSubject<SNItem[]>;
    fields: string[];
    addItem(item: SNItem);
    snRegisterControl(control: SNItemTableControl);
    snCapabilities(): SNItemTableServiceCapability[];
    store();
    send();
}
